module.exports = __webpack_public_path__ + "img/201014_WS8B_1_Diagram.489a3806.png";